/* eslint-disable max-len */
import { observer } from 'mobx-react';
// eslint-disable-next-line max-len
import { RESIGNATION_TYPE } from '../../core/configs/constants';
import { useState } from 'react';

import { useStore } from '../../core/utils/hook';
import classNames from 'classnames';




const ResignationScreen = observer(({ isPopup = false, userInfo, hide, onFetchData }) => {
    const [resignationType, setResignationType] = useState(RESIGNATION_TYPE.CONTINUE);
    const {

        groupAdminStore: {
            resignation
        },
        modalStore: {
            openWarningModal
        }
    } = useStore();

    const handleSubmit = async (id, data) => {
        try {
            // console.log(id, data);
            await resignation({ id, payload: data });
        } catch (error) {
            console.log(error);
        } finally {
            hide();
            onFetchData();
        }
    }

    // #17915 — 変更する must not act immediately; KH wants a second confirm dialog first
    // (openWarningModal already defaults to 'OK'/'キャンセル', matching the spec exactly).
    const confirmSubmit = (id, data) => {
        openWarningModal(
            'こちらの受講者は本当に退職者でよろしいですね？',
            () => handleSubmit(id, data)
        );
    }
    const onClose = () => {
        hide();
        onFetchData();
    }

    return (
        <div className={classNames(isPopup ? '' : 'col-md-10 col-lg-10 col-12 container-tool-certificate')}>
          
            <div className='row'>
                <div className='col-12 tool-certificate-input-type d-flex flex-gap-20'>
                    <div style={{ minWidth: '178px', display: 'flex', flexDirection: 'column', gap: '30px' }}>
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(3, 1fr)',
                                gap: '16px',
                                alignItems: 'center'
                            }}
                        >
                            <label style={{ color: '#6F6F6F' }} role="button" htmlFor="newRecord">
                                受講者名
                            </label>

                            <div style={{ gridColumn: 'span 2', fontWeight: 'bold' }}>
                                {userInfo?.firstName}{userInfo?.lastName}
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(3, 1fr)',
                                gap: '16px',
                                alignItems: 'center'
                            }}
                        >
                            <label style={{ color: '#6F6F6F' }} role="button" htmlFor="newRecord">
                                メールアドレス
                            </label>

                            <div style={{ gridColumn: 'span 2', fontWeight: 'bold' }}>
                                {userInfo?.email}
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '16px'
                                
                            }}
                        >
                            <label style={{ color: '#6F6F6F' }}>退職後の受講者の受講ステータスを選択してください。</label>

                            <div style={{ gridColumn: 'span 2', display: 'flex', gap: '20px', marginLeft: '20px' }}>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
                                    <input type="radio" name="option" className="custom-radio" value={RESIGNATION_TYPE.CONTINUE} checked={resignationType === RESIGNATION_TYPE.CONTINUE} onChange={() => setResignationType(RESIGNATION_TYPE.CONTINUE)} />
                                    受講を継続する
                                </label>

                                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
                                    <input type="radio" name="option" className="custom-radio" value={RESIGNATION_TYPE.DISCONTINUE} checked={resignationType === RESIGNATION_TYPE.DISCONTINUE} onChange={() => setResignationType(RESIGNATION_TYPE.DISCONTINUE)} />
                                    受講を中断する
                                </label>
                            </div>
                        </div>
                        <span style={{ color: '#EB0000' }}>
                            この受講者を「退職済み」へ変更しますか。
                        </span>
                    </div>
                       
                </div>
                <div style={{ 
                    marginTop: '10px',
                    display: 'flex', 
                    justifyContent: 'center', 
                    gap: '50px',
                    borderTop: '1px solid #d3d3d3',
                    padding: '20px' 
                }}>
                    <button 
                        className='btn-cancel-1'
                        type='button' 
                        style={{ width: '172px', height: '40px' }}
                        onClick={onClose}
                    >
                        キャンセル
                    </button>
                    <button 
                        className='btn-default-4'
                        type='submit'
                        style={{ width: '172px', height: '40px' }}
                        onClick={() => confirmSubmit(userInfo?.id, { type: resignationType, companyId: userInfo?.companyId || userInfo?.groupId })}
                    >変更する</button> 
                </div>
                
            </div>
          
            
        </div>
    )
})
export default ResignationScreen;
